//
//
//

export default {
  name: 'SectionText',
  props: {
    section: {
      type: Object
    }
  }
}
